<div class="challenge-tabs">
  <button
    class="challenge-tabs--tab"
    [class.active]="activeTab === 'details'"
    (click)="setTab('details')"
    type="button"
  >
    <span class="challenge-tabs--label-desktop">Additional Details</span>
    <span class="challenge-tabs--label-mobile">Details</span>
  </button>
  <button
    class="challenge-tabs--tab"
    [class.active]="activeTab === 'rules'"
    (click)="setTab('rules')"
    type="button"
  >
    <span class="challenge-tabs--label-desktop">Rules and Guidelines</span>
    <span class="challenge-tabs--label-mobile">Rules</span>
  </button>
  <button
    class="challenge-tabs--tab"
    [class.active]="activeTab === 'data-banks'"
    (click)="setTab('data-banks')"
    type="button"
  >
    <span class="challenge-tabs--label-desktop">Dataset and Models</span>
    <span class="challenge-tabs--label-mobile">Assets</span>
  </button>
</div>


